module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.e3242149.ttf";